export default "__VITE_ASSET__09ee72c0__$_?nuxt_component=async&nuxt_component_name=SvgoGgBg10__"